import { useNavigate, useParams } from "react-router-dom";
import { Asterisk, Award, Calendar, Clock, TextParagraph } from "react-bootstrap-icons";
import { useContext, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import UserContext from "../../contexts/UserContext";



export default function ViewLicence() {
    // states
    let codelicence = useParams();
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [suspending, setSuspending] = useState(false);
    const [activing, setActiving] = useState(false);
    const [finishing, setFinishing] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);
    const [datedeb, setDatedeb] = useState("");
    const [datefin, setDatefin] = useState("");
    const [etat, setEtat] = useState("");
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [durre, setDuree] = useState('');
    const [type, setType] = useState('');
    const [client, setClient] = useState('');
    const [typelist, setTypeLicence] = useState([]);
    const [clientlist, setClientList] = useState([]);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getTypesLicence = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=typelicence`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        setTypeLicence(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get tabonnement list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getClientList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/customers`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element?.prenom !== null ? element.nom + " (" + element.prenom + ")" : element.nom, value: element.code });
                        });

                        setClientList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getLicence = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelicence.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setName(body?.lib !== null ? body?.lib : "");
                        setDuree(body?.duree?.months !== null ? body?.duree?.months : "");
                        setDesc(body?.description !== null ? body?.description : "");
                        setType({ label: body?.libtypelicence, value: body?.typelicence });
                        setClient({ label: body?.nom + " (" + body?.abr + ")", value: body?.codeclient });
                        setDatedeb(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "")
                        setDatefin(body?.datefin !== null ? body?.datefin.slice(0, 10) : "");
                        setEtat(body?.etat);
                        setDesc(body?.description !== null ? body?.description : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    // comportements
    useEffect(() => {
        getLicence();
        getTypesLicence();
        getClientList();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: 'Supprimer?',
            message: 'Etes-vous sur de vouloir suppirmer cette licence?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelicence.code}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage("Licence supprimée avec succès.");
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete droit", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setDeleting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setDeleting(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Mise à jour?',
            message: 'Etes-vous sûr de vouloir mettre à jour cette licence?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("lib", name);
                        urlencoded.append("typelicence", type["value"]);
                        if (durre) urlencoded.append("duree", durre > 1 ? durre + " months" : durre + " month");
                        urlencoded.append("codeclient", client["value"]);
                        urlencoded.append("descr", desc);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelicence.code}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage("Licence mis à jour avec succès.");
                                setEditedstate(false);
                                getLicence();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg)
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFetching(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSuspende = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Suspendre?',
            message: 'Etes-vous sûr de vouloir suspendre cette licence?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setSuspending(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelicence.code}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Licence suspendue avec succès.");
                                setEditedstate(false);
                                getLicence();
                                setSuspending(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg)
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setSuspending(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleActive = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Réactiver?',
            message: 'Etes-vous sûr de vouloir réactiver cette licence?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setActiving(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "1");

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelicence.code}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Licence réactivée avec succès.");
                                setEditedstate(false);
                                getLicence();
                                setActiving(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg)
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setActiving(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleFinish = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Achever?',
            message: 'Etes-vous sûr de vouloir achever cette licence?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFinishing(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "3");

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses/${codelicence.code}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage("Licence achevée avec succès.");
                                setEditedstate(false);
                                getLicence();
                                setFinishing(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg)
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFinishing(false);
                        });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Licence</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quitter" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Retour</span>
                            </button>
                            {!editedstate && <button onClick={() => setEditedstate(true)}
                                title="Modifier la licence"
                                className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                            </button>}
                            {!editedstate && <button onClick={handleDelete}
                                title="Supprimer la licence"
                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                <i className="fa fa-trash mr-1"></i> <span>Supprimer</span>  {deleting && <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />}
                            </button>}
                            {!editedstate && etat === 1 && <button onClick={handleSuspende}
                                title="Suspendre la licence"
                                className="btn-shadow ml-3 btn btn-warning btn-sm float-right">
                                <i className="fa fa-arrow-down mr-1"></i> <span>Suspendre</span>  {suspending && <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />}
                            </button>}
                            {!editedstate && etat === 2 && <button onClick={handleActive}
                                title="Réactiver la licence"
                                className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                <i className="fa fa-arrow-up mr-1"></i> <span>Réactiver</span>  {activing && <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />}
                            </button>}
                            {!editedstate && etat !== 3 && <button onClick={handleFinish}
                                title="Achever la licence"
                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                <i className="fa fa-reply-all mr-1"></i> <span>Achever</span>  {finishing && <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />}
                            </button>}
                            <h6 className="m-0 ">Informations de la licence</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmitEdit}>
                                <div className="row">
                                    {/* <div className="col-md-4 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-2">
                                                                <label htmlFor="logo" className="form-label">Logo du client</label>
                                                                <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                                            </div>
                                                            <div className="col-md-12 mb-1">
                                                                <img alt="" src={logoprev} className="rounded" style={{width: "100%"}} />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="client" className="mb-1">Client</label>
                                                <Select
                                                    id="client"
                                                    name="client"
                                                    options={clientlist}
                                                    value={client}
                                                    onChange={(selected) => { setClient(selected); }}
                                                    isDisabled={editedstate ? false : true}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="typelicence" className="mb-1">Type de licence</label>
                                                <Select
                                                    id="typelicence"
                                                    name="typelicence"
                                                    options={typelist}
                                                    value={type}
                                                    onChange={(selected) => { setType(selected); }}
                                                    isDisabled={editedstate ? false : true}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="liblicene" className="mb-1">Libelle</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="liblicene">
                                                        <Award />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le libelle"
                                                        aria-label="Libelle Licence"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-6 mb-3">
                                                <label htmlFor="durrelicence" className="mb-1">Durée de licence (en mois) </label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="durrelicence">
                                                        <Clock />
                                                    </span>
                                                    <input type="number"
                                                        className="form-control"
                                                        placeholder="Entrez la durée de la licence"
                                                        aria-label="Durée de la Licence"
                                                        value={durre}
                                                        onChange={(e) => setDuree(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>}
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="datedeb" className="mb-1">Date début</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="datedeb">
                                                        <Calendar />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={datedeb}
                                                        onChange={(e) => setDatedeb(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="datefin" className="mb-1">Date fin</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="datefin">
                                                        <Calendar />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        value={datefin}
                                                        onChange={(e) => setDatefin(e.target.value)}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="etat" className="mb-1">Etat</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className={`input-group-text ${etat === 1 ? "bg-success" :
                                                        etat === 2 ? "bg-warning" :
                                                            etat === 3 ? "bg-danger" :
                                                                "bg-light"
                                                        }`
                                                    }
                                                        id="etat"
                                                    >
                                                        <Asterisk />
                                                    </span>
                                                    <input
                                                        disabled
                                                        type="text"
                                                        className={`form-control ${etat === 1 ? "text-white bg-success" :
                                                            etat === 2 ? "text-white bg-warning" :
                                                                etat === 3 ? "text-white bg-danger" :
                                                                    "bg-light"
                                                            } 
                                                                        `}
                                                        id="etat"
                                                        value={
                                                            etat === 1 ? "Licence en cours d'utilisation" :
                                                                etat === 2 ? "Licence suspendue" :
                                                                    etat === 3 ? "Licence expirée" :
                                                                        ""
                                                        }
                                                        placeholder="Etat de la licence"
                                                        onChange={(e) => setEtat(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="desc" className="mb-1">Description</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="desc">
                                                        <TextParagraph />
                                                    </span>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Entrez la description du client"
                                                        value={desc}
                                                        onChange={(e) => setDesc(e.target.value)}
                                                        disabled={editedstate ? false : true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {editedstate && <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Modifier la licence"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={name && desc && client["value"] && type["value"] ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Modifier</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                        <button onClick={() => setEditedstate(false)}
                                            title="Annuler l'opération"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                            <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                        </button>
                                    </div>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}